import React, { useState } from 'react';
import { ShieldCheck, AlertCircle } from 'lucide-react';
import { authAPI } from '../utils/authAPI';

const BootstrapAdminSetup = ({ onComplete }) => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    confirmPassword: '',
    first_name: '',
    last_name: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (field, value) => {
    setFormData((current) => ({ ...current, [field]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);

    try {
      const result = await authAPI.createBootstrapAdmin({
        username: formData.username,
        email: formData.email,
        password: formData.password,
        first_name: formData.first_name,
        last_name: formData.last_name,
      });
      onComplete(result.user);
    } catch (err) {
      setError(err.message || 'Не удалось создать администратора');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-lg w-full space-y-8">
        <div>
          <div className="mx-auto h-14 w-14 flex items-center justify-center rounded-2xl bg-blue-100 dark:bg-blue-900">
            <ShieldCheck className="h-8 w-8 text-blue-600 dark:text-blue-300" />
          </div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Создайте нового администратора
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
            Вы вошли через временный аккаунт admin/admin. После создания нового администратора временный вход будет отключен.
          </p>
        </div>

        <form className="space-y-4" onSubmit={handleSubmit}>
          {error && (
            <div className="rounded-md bg-red-50 dark:bg-red-900/20 p-4">
              <div className="flex">
                <AlertCircle className="h-5 w-5 text-red-400 flex-shrink-0" />
                <p className="ml-3 text-sm font-medium text-red-800 dark:text-red-200">{error}</p>
              </div>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input
              type="text"
              required
              placeholder="Имя пользователя *"
              className="rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={formData.username}
              onChange={(event) => handleChange('username', event.target.value)}
            />
            <input
              type="email"
              placeholder="Email"
              className="rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={formData.email}
              onChange={(event) => handleChange('email', event.target.value)}
            />
            <input
              type="text"
              placeholder="Имя"
              className="rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={formData.first_name}
              onChange={(event) => handleChange('first_name', event.target.value)}
            />
            <input
              type="text"
              placeholder="Фамилия"
              className="rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={formData.last_name}
              onChange={(event) => handleChange('last_name', event.target.value)}
            />
            <input
              type="password"
              required
              minLength={8}
              placeholder="Пароль *"
              className="rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={formData.password}
              onChange={(event) => handleChange('password', event.target.value)}
            />
            <input
              type="password"
              required
              minLength={8}
              placeholder="Повторите пароль *"
              className="rounded-md border border-gray-300 dark:border-gray-600 px-3 py-2 text-gray-900 dark:text-white dark:bg-gray-800 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={formData.confirmPassword}
              onChange={(event) => handleChange('confirmPassword', event.target.value)}
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {loading ? 'Создание...' : 'Создать администратора'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BootstrapAdminSetup;
